import { formatDatetime } from '../../../utils/fieldFormats.ts';

export interface MGraphMeasurement {
    value: string | null;
    isHighlighted: boolean;
    date: Date;
    partCount: number | null;
    partIndex: number;
    hasMultipleParts: boolean;
    source: string;
    issues: string[];
}

export interface PreparedMeasurement extends MGraphMeasurement {
    partCountLabel: string;
    tooltip: string;
    isDrawn: boolean;
}


export function prepareMeasurements(
    measurements: MGraphMeasurement[],
): PreparedMeasurement[] {
    const prepared = [];

    // Add extra fields to each measurement
    for (const measurement of measurements) {
        const partCountLabel = getPartCountLabel(measurement);
        const tooltip = getToolTipText(measurement, partCountLabel);
        const isDrawn = measurement.value != null && measurement.value !== '';

        prepared.push({
            ...measurement,
            partCountLabel,
            tooltip,
            isDrawn,
        });
    }

    return prepared;
}

function getPartCountLabel(
    measurement: MGraphMeasurement
): string {
    const labelParts = [
        measurement.partCount != null ? measurement.partCount.toString() : null,
        measurement.hasMultipleParts ? `${measurement.partIndex + 1}` : null,
    ];
    const label = labelParts.filter(it => it != null).join('.');
    return label || 'null';
}

function getToolTipText(
    measurement: MGraphMeasurement,
    partCountLabel: string | null,
): string {
    const value = `Value: ${measurement.value}`;
    const date = `Date: ${formatDatetime(measurement.date)}`;
    const partCount = `Part count: ${partCountLabel ?? ''}`;
    const source = `Tool: ${measurement.source}`;
    const issuesLabel = measurement.issues.length > 0 ? '\nIssues:' : '';
    const explanations = measurement.issues;
    const message = [value, date, partCount, source, issuesLabel, ...explanations].filter(Boolean).join('\n');
    return message;
}
